module.exports = __webpack_public_path__ + "media/04.c0e7a81a.mp4";